// This file returns an array of country objects for supported countries.

import { Country } from 'country-state-city'

// This array of controls the supported countries.
// Add a country code and the system will include it.
// "definitions" indicates which language to use for the address, 0 for default (see below)
// definitions: postcode, city, region
const supportedCountryList = [
  { country_code: 'GB', definitions: [1, 0, 2] }, // United Kingdom
  { country_code: 'US', definitions: [0, 0, 0] }, // United States
  { country_code: 'CA', definitions: [3, 0, 1] }, // Canada
  { country_code: 'PR', definitions: [0, 3, 4] }, // Puerto Rico
  { country_code: 'IN', definitions: [4, 0, 0] }, // India
  { country_code: 'PH', definitions: [0, 0, 3] }, // Philippines
  { country_code: 'AU', definitions: [0, 2, 0] }, // Australia
  { country_code: 'SG', definitions: [0, 1, 4] }, // Singapore
  { country_code: 'ES', definitions: [0, 0, 1] }, // Spain
  { country_code: 'DE', definitions: [0, 0, 4] }, // Germany
  { country_code: 'NL', definitions: [0, 0, 4] }, // Netherlands
  { country_code: 'SE', definitions: [0, 0, 4] }, // Sweden
  { country_code: 'FR', definitions: [0, 0, 4] }, // France
  { country_code: 'AT', definitions: [0, 0, 4] }, // Austria
  { country_code: 'DK', definitions: [0, 0, 4] }, // Denmark
  { country_code: 'BE', definitions: [0, 0, 4] }, // Belgium
  { country_code: 'CN', definitions: [0, 0, 1] }, // China
  { country_code: 'HK', definitions: [5, 4, 5] }, // Hong Kong
  { country_code: 'JP', definitions: [0, 0, 6] }, // Japan
  { country_code: 'EE', definitions: [0, 0, 4] }, // Estonia
  { country_code: 'PT', definitions: [0, 0, 4] }, // Portugal
  { country_code: 'RU', definitions: [0, 0, 3] }, // Russia
  { country_code: 'CR', definitions: [0, 0, 3] }, // Costa Rica
  { country_code: 'PL', definitions: [0, 0, 4] }, // Poland
  { country_code: 'IE', definitions: [6, 0, 7] }, // Ireland
  { country_code: 'LT', definitions: [0, 0, 4] }, // Lithuania
  { country_code: 'ZA', definitions: [0, 0, 1] }, // South Africa
  { country_code: 'UA', definitions: [0, 0, 3] }, // Ukraine
  { country_code: 'HN', definitions: [0, 0, 3] }, // Honduras
  { country_code: 'AL', definitions: [0, 0, 3] }, // Albania
  { country_code: 'BY', definitions: [0, 0, 3] }, // Belarus
  { country_code: 'GE', definitions: [0, 0, 3] }, // Georgia
  { country_code: 'IL', definitions: [0, 0, 4] }, // Israel
  { country_code: 'LK', definitions: [0, 0, 4] }, // Sri Lanka
  { country_code: 'IT', definitions: [0, 0, 1] }, // Italy
  { country_code: 'GR', definitions: [0, 0, 3] }, // Greece
  { country_code: 'NG', definitions: [5, 0, 0] }, // Nigeria
  { country_code: 'CH', definitions: [0, 0, 8] }, // Switzerland
  { country_code: 'GD', definitions: [0, 0, 3] }, // Grenada
  { country_code: 'PK', definitions: [0, 0, 3] }, // Pakistan
  { country_code: 'TN', definitions: [0, 0, 3] }, // Tunisia
  { country_code: 'MX', definitions: [3, 0, 0] }, // Mexico
  { country_code: 'KN', definitions: [0, 0, 3] }, // Saint Kitts and Nevis
  { country_code: 'CO', definitions: [5, 0, 3] }, // Colombia
  { country_code: 'KR', definitions: [0, 0, 9] }, // South Korea
  { country_code: 'DZ', definitions: [0, 0, 3] }, // Algeria
  { country_code: 'AO', definitions: [7, 0, 1] }, // Angola
  { country_code: 'AR', definitions: [0, 0, 3] }, // Argentina
  { country_code: 'AZ', definitions: [0, 0, 3] }, // Azerbaijan
  { country_code: 'BS', definitions: [7, 0, 3] }, // Bahamas
  { country_code: 'BH', definitions: [5, 0, 4] }, // Bahrain
  { country_code: 'BO', definitions: [7, 0, 10] }, // Bolivia
  { country_code: 'BR', definitions: [0, 0, 3] }, // Brazil
  { country_code: 'BN', definitions: [0, 0, 3] }, // Brunei
  { country_code: 'CM', definitions: [0, 0, 3] }, // Cameroon
  { country_code: 'TD', definitions: [0, 0, 3] }, // Chad
  { country_code: 'CG', definitions: [0, 0, 3] }, // Republic of Congo
  { country_code: 'CD', definitions: [0, 0, 3] }, // Congo Kinshasa (DRC)
  { country_code: 'EC', definitions: [0, 0, 1] }, // Ecuador
  { country_code: 'EG', definitions: [0, 0, 3] }, // Egypt
  { country_code: 'GA', definitions: [0, 0, 3] }, // Gabon
  { country_code: 'GH', definitions: [0, 0, 5] }, // Ghana
  { country_code: 'GT', definitions: [0, 0, 10] }, // Guatemala
  { country_code: 'GN', definitions: [0, 0, 3] }, // Guinea
  { country_code: 'GY', definitions: [0, 0, 3] }, // Guyana
  { country_code: 'HU', definitions: [5, 1, 2] }, // Hungary
  { country_code: 'IS', definitions: [0, 0, 4] }, // Iceland
  { country_code: 'ID', definitions: [0, 0, 1] }, // Indonesia
  { country_code: 'IQ', definitions: [0, 0, 3] }, // Iraq
  { country_code: 'CI', definitions: [0, 0, 3] }, // Ivory Coast
  { country_code: 'KZ', definitions: [0, 0, 3] }, // Kazakhstan
  { country_code: 'KE', definitions: [0, 0, 3] }, // Kenya
  { country_code: 'KW', definitions: [0, 0, 4] }, // Kuwait
  { country_code: 'LY', definitions: [0, 0, 3] }, // Libya
  { country_code: 'MY', definitions: [0, 0, 3] }, // Malaysia
  { country_code: 'MZ', definitions: [7, 0, 1] }, // Mozambique
  { country_code: 'MM', definitions: [0, 0, 3] }, // Myanmar
  { country_code: 'NA', definitions: [0, 0, 3] }, // Namibia
  { country_code: 'NZ', definitions: [0, 0, 11] }, // New Zealand
  { country_code: 'NI', definitions: [0, 0, 10] }, // Nicaragua
  { country_code: 'NE', definitions: [0, 0, 3] }, // Niger
  { country_code: 'NO', definitions: [0, 0, 4] }, // Norway
  { country_code: 'OM', definitions: [0, 0, 3] }, // Oman
  { country_code: 'PG', definitions: [0, 0, 3] }, // Papua New Guinea
  { country_code: 'PE', definitions: [0, 0, 3] }, // Peru
  { country_code: 'QA', definitions: [0, 0, 3] }, // Qatar
  { country_code: 'RO', definitions: [0, 0, 7] }, // Romania
  { country_code: 'SA', definitions: [0, 0, 3] }, // Saudi Arabia
  { country_code: 'RS', definitions: [0, 0, 12] }, // Serbia
  { country_code: 'SD', definitions: [0, 0, 3] }, // Sudan
  { country_code: 'SR', definitions: [7, 0, 3] }, // Suriname
  { country_code: 'TW', definitions: [0, 0, 3] }, // Taiwan
  { country_code: 'TH', definitions: [0, 0, 3] }, // Thailand
  { country_code: 'TT', definitions: [0, 0, 3] }, // Trinidad and Tobago
  { country_code: 'TR', definitions: [0, 0, 1] }, // Turkey
  { country_code: 'TM', definitions: [0, 0, 3] }, // Turkmenistan
  { country_code: 'AE', definitions: [7, 0, 13] }, // United Arab Emirates
  { country_code: 'VE', definitions: [0, 0, 3] }, // Venezuela
  { country_code: 'VN', definitions: [5, 0, 4] }, // Vietnam
  { country_code: 'YE', definitions: [0, 0, 3] } // Yemen
]

// Define language specific to certain countries
const postcodeDefinitions = [
  'Postcode/Zip', //            0
  'Postcode', //                1
  'Zip', //                     2
  'Postal Code', //             3
  'Pin Code', //                4
  'Postcode/Zip (Optional)', // 5
  'Eircode (Optional)', //      6
  'N/A' //                      7 - will cause the field to be hidden
]
const townCityDefinitions = [
  'Town/City', //            0
  'Town/City (Optional)', // 1
  'Suburb', //               2
  'Municipality', //         3
  'Town/District', //        4
  'N/A' //                   5 - will cause the field to be hidden
]
const stateProvinceDefinitions = [
  'State', //                  0
  'Province', //               1
  'County (Optional)', //      2
  'State/County', //           3
  'N/A', //                    4 - will cause the field to be hidden
  'Region', //                 5
  'Prefecture', //             6
  'County', //                 7
  'Canton (Optional)', //      8
  'Province (Optional)', //    9
  'Department', //             10
  'Region (Optional)', //      11
  'District (Optional)', //    12
  'State/County (Optional)' // 13
]

const createCountry = (countryFromList, countryData) => {
  const [postcodeLabelIndex, cityLabelIndex, stateLabelIndex] = countryFromList.definitions
  const result = {
    country_code: countryData.isoCode,
    name: countryData.name === 'Netherlands The' ? 'The Netherlands' : countryData.name,
    labels: {
      postcode: postcodeDefinitions[postcodeLabelIndex],
      city: townCityDefinitions[cityLabelIndex],
      region: stateProvinceDefinitions[stateLabelIndex]
    }
  }

  return result
}

// Returns array of country objects formatted with labels
// required parameter: portal.supported_countries
export const supportedCountries = portalSupportedCountries => {
  const allCountries = Country.getAllCountries()
  const supportedCountryCodes = supportedCountryList.map(c => c.country_code)
  const portalHasSpecificCountries = Array.isArray(portalSupportedCountries) && portalSupportedCountries.length > 0

  const effectiveCountryCodes = portalHasSpecificCountries
    ? supportedCountryCodes.filter(code => portalSupportedCountries.includes(code))
    : supportedCountryCodes

  return allCountries
    .filter(countryData => effectiveCountryCodes.includes(countryData.isoCode))
    .map(countryData => {
      const localCountryData = supportedCountryList.find(c => c.country_code === countryData.isoCode)
      return createCountry(localCountryData, countryData)
    })
}

export const getAllCountries = () => {
  return Country.getAllCountries()
    .filter(countryData => {
      // get array of codes to check
      const supportedCountryCodes = supportedCountryList.map(c => c.country_code)

      const isCountrySupported = supportedCountryCodes.includes(countryData.isoCode)
      return isCountrySupported
    })
    .map(countryData => {
      const localCountryData = supportedCountryList.find(c => c.country_code === countryData.isoCode)
      return createCountry(localCountryData, countryData)
    })
}

export default supportedCountries
